import React from 'react'
import { map, isPresent } from 'lodash'
import ClientNameWithStatus from 'FoundationalComponents/ClientNameWithStatus'

import BooleanIcon from 'UI/BooleanIcon'
import PowerStateCell from 'UI/Table/components/PowerStateCell'
import PercentCell from 'UI/Table/components/PercentCell'
import TableCellList from 'UI/Table/components/TableCellList'

import { humanizeGB } from 'Decorators/SizeDecorator'

const ColumnTransformer = (columns) => map(columns, (column, index) => {
  switch (column.type) {
    case 'link':
      column.Cell = (data) => (
        <a href={data.original.href}>
          {data.value}
        </a>
      )

      break;
    case 'link_blank':
      column.Cell = (data) => (
        <a href={data.original.href} target="_blank">
          {data.value}
        </a>
      )

      break;
    case 'boolean':
      column.Cell = ({ value }) => (
        <BooleanIcon booleanValue={column.invertValue ? !value : value} trueIcon={column.trueIcon} falseIcon={column.falseIcon} />
      )

      break;
    case 'trueOrGray':
      column.Cell = (data) => (
        <BooleanIcon booleanValue={data.value} trueIcon={column.trueIcon} falseIcon={column.falseIcon} />
      )

      break;
    case 'percent':
      column.style = { ...column.style, textAlign: 'right' }
      column.Cell = (data) => (
        <PercentCell value={data.value} rag={column.rag} ragLimits={column.ragLimits} valueIsSmaller={column.valueIsSmaller} />
      )

      break;
    case 'list':
      column.Cell = (data) => (
        <TableCellList list={data.value} />
      )

      break;
    case 'humanizeGB':
      column.style = { ...column.style, textAlign: 'right' }
      column.Cell = ({ value }) => humanizeGB(value)

      break;
    case 'number':
      column.style = { ...column.style, textAlign: 'right' }

      break;
    case 'powerState':
      column.width = column.width || 100
      column.Cell = (data) => (
        <PowerStateCell powerState={data.value} />
      )

      break;
    case 'clientNameWithStatus':
      column.Cell = (data) => (
        <ClientNameWithStatus data={data} />
      )

      break;
    default:
      column
  }

  if (isPresent(column.columns)) {
    column.columns = ColumnTransformer(column.columns)
  }

  return column
})

export default ColumnTransformer
